module.exports = __webpack_public_path__ + "img/logo-menu.44ef0fb2.png";